<template>
  <div>
    <v-app-bar
      id="home-app-bar"
      app
      color="white"
      elevation="1"
      height="80"
      elevate-on-scroll
    >
      <template
        v-if="showLogo"
        class="hidden-md-and-up"
      >
        <base-img
          :src="require('@/assets/logo.png')"
          class="mr-3"
          contain
          max-width="100"
          width="100%"
        />
      </template>

      <v-spacer />

      <div>
        <v-tabs
          v-model="tab"
          class="hidden-sm-and-down"
        >
          <v-tab
            v-for="(item) in items"
            :key="item.id"
            :exact="item.id === 'home'"
            :ripple="false"
            active-class="text--primary"
            class="font-weight-bold"
            min-width="96"
            text
            @click="tabClick(item.section)"
          >
            {{ item.title }}
          </v-tab>
        </v-tabs>
      </div>

      <v-app-bar-nav-icon
        class="hidden-md-and-up"
        @click="drawer = !drawer"
      />
    </v-app-bar>

    <home-drawer
      v-model="drawer"
      :items="items"
    />
  </div>
</template>

<script>
  import { eventBus } from '../../main'

  export default {
    name: 'HomeAppBar',

    components: {
      HomeDrawer: () => import('./Drawer'),
    },
    data: () => ({
      drawer: null,
      tab: 0,
      items: [{
                id: 'home',
                section: '#home',
                title: 'Home',
                index: 0,
              },
              {
                id: 'services',
                section: '#services',
                title: 'What we do',
                index: 1,
              },
              {
                id: 'about',
                section: '#about-us',
                title: 'Who we are',
                index: 2,
              },
              {
                id: 'contact',
                section: '#contact-us',
                title: 'Contact us',
                index: 3,
              },
      ],
    }),
    computed: {
      showLogo () {
        if (this.tab !== 0 || this.$vuetify.breakpoint.smAndDown) {
          return true
        } else {
          return false
        }
      },
    },
    created () {
      this.listenSelectTabEvent()
    },
    methods: {
      tabClick (option) {
        var vm = this
        vm.listenSelectTabEvent(false)
        vm.$vuetify.goTo(option)
        setTimeout(function () {
          vm.listenSelectTabEvent()
        }, 2000)
      },
      listenSelectTabEvent (active = true) {
        if (active) {
          eventBus.$on('selectTab', (tabToSelect) => {
            var index = this.items.filter(x => x.id === tabToSelect)[0].index
            if (index !== null) {
              this.tab = index
            }
          })
        } else {
          eventBus.$off('selectTab')
        }
      },
    },
  }
</script>

<style lang="sass">
  #home-app-bar
    .v-tabs-slider
      max-width: 24px
      margin: 0 auto

    .v-tab
      &::before
        display: none
</style>
